import React, { forwardRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { editUserStreamsSettings } from '../../../apiclients/streamsapi_bridge';

const DelUsrStreamsSpeedDial = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false)

    async function removeSpeedDial(e) {
        e.preventDefault();
        console.log(props.useragent);
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setIsloading(true);
        let update = {
            reqid: 51,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            agentid: props.useragent,
            streams_speed_dials: {
            remove_speed_dials: [parseInt(props.speedNo)]
            }

        }
        console.log("Delete speed Dial request:::::: "+update)
        let deletespeed = await editUserStreamsSettings(update);
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
        let deleteMsg = await deletespeed.json();
        console.log("Response... ");
        console.log(deleteMsg);
        if (deleteMsg.status == "Failed") {
            // localStorage.setItem(
            //     "user_create_f",
            //     "Something went wrong, Please try again after sometime"
            // );

        } else {
            props.setSuccessMessage(deleteMsg.message);
            props.setDeleteFlag(true);
            props.onClose();
        }
    }
    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            <div>
                <span className="phrecording">{t("RemoveUserStreamsSpeedDialtxt")}</span>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => removeSpeedDial(e)}>
                    {t("remove")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => removeSpeedDial(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter> */}

        </>
    )
});

export default DelUsrStreamsSpeedDial
